import React, { useState, useEffect } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const handleNav = () => {
        setNav(prevNav => !prevNav);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`sticky top-0 w-full z-50 transition-all duration-300 ${
            scrolled ? 'bg-black/80 backdrop-blur-md shadow-lg' : 'bg-black/60 backdrop-blur-md'
        }`}>
            <div className='flex justify-between items-center h-20 max-w-6xl mx-auto px-6 text-white'>
                <Link to='/' className='group'>
                    <h1 className='text-2xl font-bold tracking-wider transition-all duration-300 group-hover:scale-105'>
                        <span className='text-[#00d59a]'>S</span>
                        <span className='text-white mx-1'>·</span>
                        <span className='text-[#00d59a]'>K</span>
                        <span className='text-white mx-1'>·</span>
                        <span className='text-[#00d59a]'>S</span>
                    </h1>
                </Link>
                <ul className='hidden md:flex space-x-8'>
                    <li>
                        <Link to='/' className='relative group text-gray-300 hover:text-white transition-colors duration-300'>
                            Home
                            <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d59a] group-hover:w-full transition-all duration-300'></span>
                        </Link>
                    </li>
                    <li>
                        <Link to='/projects' className='relative group text-gray-300 hover:text-white transition-colors duration-300'>
                            Projects
                            <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d59a] group-hover:w-full transition-all duration-300'></span>
                        </Link>
                    </li>
                    <li>
                        <Link to='/timeline' className='relative group text-gray-300 hover:text-white transition-colors duration-300'>
                            Timeline
                            <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d59a] group-hover:w-full transition-all duration-300'></span>
                        </Link>
                    </li>
                </ul>
                <div onClick={handleNav} className='block md:hidden cursor-pointer hover:text-[#00d59a] transition-colors duration-300'>
                    {nav ? <AiOutlineClose size={24} /> : <AiOutlineMenu size={24} />}
                </div>
                <ul className={nav ? 'fixed left-0 top-0 w-[70%] h-full bg-black/95 backdrop-blur-lg ease-in-out duration-500' : 'ease-in-out duration-500 fixed left-[-100%]'}>
                    <h1 className='text-2xl font-bold tracking-wider m-8'>
                        <span className='text-[#00d59a]'>S</span>
                        <span className='text-white mx-1'>·</span>
                        <span className='text-[#00d59a]'>K</span>
                        <span className='text-white mx-1'>·</span>
                        <span className='text-[#00d59a]'>S</span>
                    </h1>
                    <li className='p-6 border-b border-gray-800 hover:bg-gray-900/50 transition-colors duration-300'>
                        <Link to='/' onClick={handleNav}>Home</Link>
                    </li>
                    <li className='p-6 border-b border-gray-800 hover:bg-gray-900/50 transition-colors duration-300'>
                        <Link to='/projects' onClick={handleNav}>Projects</Link>
                    </li>   
                    <li className='p-6 border-b border-gray-800 hover:bg-gray-900/50 transition-colors duration-300'>
                        <Link to='/timeline' onClick={handleNav}>Timeline</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Navbar;